// extracted by mini-css-extract-plugin
export var contentBody = "_61-9";
export var headerImage = "_61-2";
export var imageButton = "_61-7";
export var imageButtonIcon = "_61-8";
export var imageHeader = "_61-4";
export var imageHeaderText = "_61-5";
export var imageOverlay = "_61-3";
export var imageTitle = "_61-6";
export var imageWrapper = "_61-1";
export var taskList = "_61-a";
export var widget = "_61-0";